import { useState, useEffect, useRef } from 'react';

export default function useChartLogic(initialChartData) {
  const chartRef = useRef(null);
  
  // 状态管理
  const [data, setData] = useState(initialChartData);
  const [hoverY, setHoverY] = useState(null);
  const [chartWidth, setChartWidth] = useState(576);

  // 计算派生值
  const lastPrice = data[data.length - 1]?.price;
  const prices = data.map(d => d.price);
  const rawMin = Math.min(...prices);
  const rawMax = Math.max(...prices);
  
  // 计算实际价格范围
  const priceRange = rawMax - rawMin;
  
  // 统一使用固定比例的padding，简化计算
  const padding = priceRange * 0.25; // 统一15%的padding
  
  const minY = rawMin - padding;
  const maxY = rawMax + padding;
  
  // 调试日志：检查Y轴范围计算
  // if (data.length > 0) {
  //   console.log(`📈 Y轴范围计算:`, {
  //     rawMin, 
  //     rawMax, 
  //     priceRange, 
  //     padding, 
  //     minY, 
  //     maxY,
  //     totalRange: maxY - minY
  //   });
  // }

  // 监听窗口变化和图表尺寸
  useEffect(() => {
    if (chartRef.current) {
      setChartWidth(chartRef.current.width.animVal.value);
    }
    
    const handleResize = () => {
      if (chartRef.current) {
        setChartWidth(chartRef.current.width.animVal.value);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 当传入的chartData更新时，同步更新图表数据
  useEffect(() => {
    if (initialChartData && initialChartData.length > 0) {
      setData(initialChartData);
    }
  }, [initialChartData]);

  // 事件处理函数
  const handleMouseMove = (state) => {
    if (state && state.activeCoordinate && state.activeCoordinate.y) {
      const y = state.activeCoordinate.y;
      setHoverY(160 - y);
    } else {
      setHoverY(null);
    }
  };

  const handleMouseLeave = () => {
    setHoverY(null);
  };

  // 点击处理函数
  const handleAreaClick = (onAreaClick) => {
    if (onAreaClick) {
      onAreaClick('unified'); // 统一点击事件
    }
  };

  return {
    // 数据
    data,
    chartRef,
    
    // 计算值
    lastPrice,
    prices,
    minY,
    maxY,
    hoverY,
    chartWidth,
    
    // 事件处理
    handleMouseMove,
    handleMouseLeave,
    handleAreaClick
  };
}
